import keyboardEventCode from './keyboard-event-code'

export default keyboardEventCode
